<template>
<md-layout md-flex="100" md-gutter="16">
    <md-layout md-flex="25" class="project-box-container" v-for="project in projects" :key="project.id">
        <dashboard-project-box :project="project"/>
    </md-layout>
</md-layout>
</template>

<script>
/**
 * Module for managing a grid of project boxes
 */

import DashboardProjectBox from '@/components/dashboard/project-box';

const ProjectGrid = {
    name: 'ProjectGrid',
    props: ['projects'],
    data: function() {
        return {};
    },
    methods: {
    },
    components: {
        'dashboard-project-box': DashboardProjectBox
    }
};
export default ProjectGrid;

</script>

<style lang="scss">
.project-box-container {
    margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// project-grid.vue?33fc1d3f